import React from 'react';

// Reusable form fields for project metadata. Used inside SaveProjectModal.
// Validation lives in the parent — this is presentational only.
//
// showClientFields (create mode only): collects the cover page's Property /
// Client Details up front, once, instead of the user having to click into
// each field on the Cover Page every time. None of these are required —
// skip them here and fill them in later on the Cover Page if needed.
export default function ProjectForm({ values, onChange, errors = {}, disabled = false, showClientFields = false }) {
  const update = (field) => (e) => onChange({ ...values, [field]: e.target.value });
  const updateClient = (field) => (e) => onChange({ ...values, clientDetails: { ...(values.clientDetails || {}), [field]: e.target.value } });
  const client = values.clientDetails || {};

  return (
    <div style={{ display: 'flex', flexDirection: 'column', gap: 14 }}>
      <label style={labelStyle}>
        Project Name <span style={{ color: '#E74C3C' }}>*</span>
        <input
          type="text"
          value={values.name || ''}
          onChange={update('name')}
          disabled={disabled}
          autoFocus
          maxLength={120}
          placeholder="e.g. 32 Park Avenue Floor 1"
          style={{ ...inputStyle, borderColor: errors.name ? '#E74C3C' : '#d1d5db' }}
        />
        {errors.name && <span style={errorTextStyle}>{errors.name}</span>}
      </label>

      {/* Description is skipped on the "Create Project" form (showClientFields)
          per explicit request — still shown for the "Save Changes" (edit) form. */}
      {!showClientFields && (
        <label style={labelStyle}>
          Description (optional)
          <textarea
            value={values.description || ''}
            onChange={update('description')}
            disabled={disabled}
            maxLength={500}
            rows={3}
            placeholder="Notes about this configuration..."
            style={{ ...inputStyle, resize: 'vertical', minHeight: 70 }}
          />
        </label>
      )}

      {showClientFields && (
        <div style={{ borderTop: '1px solid #e5e7eb', paddingTop: 14, display: 'flex', flexDirection: 'column', gap: 14 }}>
          <div style={{ fontSize: 13, fontWeight: 600, color: '#374151' }}>
            Property / Client Details <span style={{ fontWeight: 400, color: '#9ca3af' }}>(optional — auto-fills the Cover Page)</span>
          </div>
          <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 12 }}>
            <label style={labelStyle}>
              Owner Name
              <input type="text" value={client.name || ''} onChange={updateClient('name')} disabled={disabled}
                placeholder="Enter owner name" style={inputStyle} />
            </label>
            <label style={labelStyle}>
              Contact Number
              <input type="text" value={client.phone || ''} onChange={updateClient('phone')} disabled={disabled}
                placeholder="Enter contact number" style={inputStyle} />
            </label>
            <label style={labelStyle}>
              Email
              <input type="email" value={client.email || ''} onChange={updateClient('email')} disabled={disabled}
                placeholder="Enter email" style={inputStyle} />
            </label>
            <label style={labelStyle}>
              Property Type
              <input type="text" value={client.propertyType || ''} onChange={updateClient('propertyType')} disabled={disabled}
                placeholder="e.g. Residential Flat" style={inputStyle} />
            </label>
            <label style={{ ...labelStyle, gridColumn: '1 / -1' }}>
              Property Address
              <input type="text" value={client.address || ''} onChange={updateClient('address')} disabled={disabled}
                placeholder="Enter property address" style={inputStyle} />
            </label>
            <label style={labelStyle}>
              Date of Visit
              <input type="date" value={client.dateOfVisit || ''} onChange={updateClient('dateOfVisit')} disabled={disabled}
                style={inputStyle} />
            </label>
          </div>
        </div>
      )}
    </div>
  );
}

const labelStyle = {
  display: 'flex',
  flexDirection: 'column',
  gap: 6,
  fontSize: 13,
  color: '#374151',
  fontWeight: 500,
};

const inputStyle = {
  padding: '8px 10px',
  border: '1px solid #d1d5db',
  borderRadius: 6,
  fontSize: 14,
  outline: 'none',
  fontFamily: 'inherit',
};

const errorTextStyle = {
  color: '#E74C3C',
  fontSize: 12,
  fontWeight: 400,
};
